import { Col } from "reactstrap";
import { H4 } from "../../../../AbstractElements";
import { BorderWidth } from "../../../../Constant";
import { BORDER_WIDTH } from "../../../../Data/UiKit/HelperClasses";

export const BorderWidths = () => {
  return (
    <Col xl="3" sm="6">
      <div className="border-wrapper h-100 alert-light-light dark-helper">
        <H4 className="mb-3">{BorderWidth}</H4>
        <div className="d-flex align-items-center mb-2 gap-2">
            <div className="helper-box border-1 border"> </div>
            <span>.border-1</span>
          </div>
        {BORDER_WIDTH.map((item, index) => (
          <div className="d-flex align-items-center mb-2 gap-2" key={index}>
            <div className={`helper-box ${item} border`}> </div>
            <span>.{item}</span>
          </div>
        ))}
      </div>
    </Col>
  );
};
